import { connect } from 'react-redux'
import SettingNewRules from '..'
import { getEligibilityCriteria } from '../../../../Events/actions'
import {
  checkRuleSet,
  createRules,
  getInstituteRulesById,
  ruleOverwrite,
  setUpNewRules,
  updateRules,
} from '../../../action'
import selectors from '../../../selectors'
const mapStateToProps = state => ({
  //   rolesList: ruleSelector.getRolesList(state),
  //   rules: ruleSelector.getRuleEngine(state),
  //   corporatesList: ruleSelector.getCorpList(state),
  //   permissions: authSelector.getUserPermissions(state),
  instituteCampusId: state.auth.instituteDetails.id,
  rulesDegreesMetrics: selectors.getRulesDegreesMetrics(state),
  selectedDegStreamList: selectors.getSelectedDegreeAndDepart(state),
})

const mapDispatchToProps = {
  getEligibilityCriteria,
  createRules,
  getInstituteRulesById,
  setUpNewRules,
  checkRuleSet,
  updateRules,
  ruleOverwrite,
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingNewRules)
